import { ExternalLink } from "lucide-react";
import type { SourcesData } from "../types/content";

export function SourceLedger({
  sources,
  sourceIds,
  referenceIds,
}: {
  sources: SourcesData;
  sourceIds: string[];
  referenceIds: string[];
}) {
  const articles = sources.articles.filter((source) => sourceIds.includes(source.id));
  const references = sources.references.filter((source) => referenceIds.includes(source.id));
  return (
    <section className="sources-section" id="sources" aria-labelledby="sources-title">
      <div className="section-heading">
        <h2 id="sources-title">来源与边界</h2>
        <p>
          当前文档只保存独立综合稿、原创图和必要元数据。外部网页仍归原作者与
          发布平台所有，完整上下文请访问原链接。
        </p>
      </div>

      <div className="source-columns">
        <div>
          <h3>本文原始来源</h3>
          <ol className="source-list">
            {articles.map((source) => (
              <li key={source.id} id={`source-${source.id.toLowerCase()}`}>
                <span>{source.id}</span>
                <a href={source.url} target="_blank" rel="noreferrer">
                  {source.title}
                  <ExternalLink aria-hidden="true" />
                </a>
              </li>
            ))}
          </ol>
        </div>
        {references.length > 0 && <div>
          <h3>本文延伸论文</h3>
          <ol className="source-list reference-list">
            {references.map((source) => (
              <li key={source.id} id={`source-${source.id.toLowerCase()}`}>
                <span>{source.id}</span>
                <a href={source.url} target="_blank" rel="noreferrer">
                  {source.title}
                  <ExternalLink aria-hidden="true" />
                </a>
              </li>
            ))}
          </ol>
        </div>}
      </div>
      <p className="source-meta">
        来源快照：<code>{sources.repository_commit}</code> · 本页不再分发外部文章全文。
      </p>
    </section>
  );
}
